import { render } from "./UsersPermissionSet.vue?vue&type=template&id=9eda3752"
import script from "./UsersPermissionSet.vue?vue&type=script&lang=js"
export * from "./UsersPermissionSet.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__